<template>
    <b-modal id="import-modal" ref="import-modal" :no-close-on-backdrop="true" :no-close-on-esc="true"  centered size="lg">
        <template #modal-title>Import Tools From project</template>

        <b-alert id="importError" variant="danger" :show="errorMessage !== ''">{{ errorMessage }}</b-alert>

        <div class="accordion" role="tablist">
            <b-card v-for="project in projects" v-if="project.id !== $store.state.project.id" v-bind:key="project.id" class="mb-1"
                    no-body>
                <b-card-header class="p-1" header-tag="header" role="tab">
                    <b-button v-b-toggle="'accordion-' + project.id" block variant="danger">
                        {{ project.name }}
                    </b-button>
                </b-card-header>
                <b-collapse :id="'accordion-' + project.id" :accordion="'accordion-' + project.id" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <template v-if="typeof tools[project.id] !== 'undefined' && tools[project.id].length > 0">
                                <div class="row">

                                    <div v-for="tool in tools[project.id]" class="col-3 toolIcon text-center toolType" @click="toggleToolSelection(tool.id)">

                                        <b-card class="mb-2">
                                            <b-card-text>
                                                <Icon
                                                    v-if="tool.type === 'firestop'"
                                                    :bottom-text="tool.show_lower_detail ? tool.short_name : ''"
                                                    :color="tool.color"
                                                    :middle-text="tool.show_running_number ? '1' : ''"
                                                    :tool-icon="tool.icon"
                                                    :tool-type="tool.type"
                                                    :top-text="tool.show_upper_detail ? 'Detail' : ''"
                                                ></Icon>
                                                <Icon
                                                    v-else
                                                    :bottom-text="tool.show_lower_detail ? tool.short_name : ''"
                                                    :color="tool.color"
                                                    :middle-text="tool.show_running_number ? '1' : ''"
                                                    :tool-icon="tool.icon"
                                                    :tool-type="tool.type"
                                                    :top-text="tool.show_upper_detail ? (tool.text_1 ? tool.text_1 : '') : ''"
                                                ></Icon>

                                                <p class="one-liner mt-2">{{ tool.long_name }}</p>
                                                <p class="one-liner">({{ tool.short_name }})</p>


                                            </b-card-text>
                                            <b-button type="button" variant="normal" size="sm">
                                                <b-icon-square scale="1" v-if="!selectedTools.includes(tool.id)"></b-icon-square>
                                                <b-icon-check-square scale="1" v-else></b-icon-check-square>
                                            </b-button>
                                        </b-card>

                                    </div>
                                </div>
                            </template>
                            <template v-else>This project has no tools assigned</template>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>


        <template #modal-footer="{ cancel, ok }">
            <b-button @click="cancel">Cancel</b-button>

            <b-button :disabled="!hasManagerPermission('site_tools.edit')" v-if="selectedTools.length > 0" variant="danger"
                      @click="importTools">Import selected tools
            </b-button>
        </template>

    </b-modal>
</template>

<script>

import axios from "axios";
import EventBus from "@mobile/utils/event-bus";
import Icon from "./Icon";

export default {
    name: 'ImportModal',
    components: {Icon},
    props: {},
    data() {
        return {
            projects: [],
            tools: {},
            selectedTools: [],
            errorMessage: '',
        }
    },
    computed: {},
    mounted() {

        this.$root.$on('bv::modal::show', () => {
            this.loadProjects();
        });

        this.$root.$on('bv::modal::hide', () => {
            this.selectedTools = [];
            this.errorMessage = '';
        });

        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            const projectID = collapseId.replace('accordion-', '');
            if (!isNaN(projectID) && isJustShown && typeof this.tools[projectID] === 'undefined') {
                this.loadProjectTools(projectID);
            }
        });

    },
    methods: {
        loadProjects() {
            let token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/projects',
                method: 'GET',
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.projects = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadProjectTools(projectID) {

            if (projectID && !isNaN(projectID)) {

                let token = this.$store.state.token;
                let url = this.$store.getters.apiCompanyBase + '/projects/' + projectID + '/marking-tools';
                let method = 'GET';

                EventBus.$emit('SHOW_LOADER', {
                    title: "Loading project tools",
                    message: "Please wait, loading project tools..."
                });

                axios({
                    url: url,
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.tools[projectID] = response.data.data;
                        this.$forceUpdate();
                    })
                    .catch(error => {
                        console.log('err', error);

                        alert('Unable to get project tools.');
                    })
                    .finally(() => EventBus.$emit('HIDE_LOADER'))
            }
        },
        toggleToolSelection(toolID){

            if(!this.selectedTools.includes(toolID)){
                console.log('not includes');
                this.selectedTools.push(toolID);
            }
            else{
                this.selectedTools = this.selectedTools.filter(item =>{
                    return item !== toolID
                });

            }
        },
        importTools(){
            console.log('import tools');
            this.errorMessage = '';

            let token = this.$store.state.token;
            let url = this.$store.getters.apiProjectBase + '/marking-tools/import';
            let method = 'POST';

            EventBus.$emit('SHOW_LOADER', {
                title: "Importing project tools",
                message: "Please wait, importing selected project tools."
            });

            axios({
                url: url,
                method: method,
                data: {tools: this.selectedTools},
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    console.log(response);
                    EventBus.$emit('HIDE_LOADER');
                    if(response.data.success){
                        this.$refs['import-modal'].hide()
                        this.$emit('toolsImported');
                    }
                    else{
                        this.errorMessage = response.data.message ? response.data.message : 'Failed to import project tools';

                        document.querySelector('#import-modal').scrollTo(0, 0);

                    }

                })
                .catch(error => {
                    console.log('err', error);
                    EventBus.$emit('HIDE_LOADER');
                    alert('Unable to import project tools');
                });
        }
    },
    watch: {},
}
</script>
<style scoped>
.one-liner{
    width: 100%;
    padding: 0;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}
</style>
